import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useStore, useStoreActions } from '~/contexts';
import { selectors } from '~/store/state-selectors';
export function useSetWorksAtOptimisticUpdate() {
    const { setWorksAt } = useStoreActions();
    const worksAt = useStore(selectors.user.business);
    return (isSampleRelationship, externallySign)=>{
        var _worksAt_key;
        if (!worksAt) {
            return;
        }
        const key = isSampleRelationship ? 'numSampleAgreements' : 'numSaleAgreements';
        const { pending, approved } = (_worksAt_key = worksAt[key]) !== null && _worksAt_key !== void 0 ? _worksAt_key : {
            pending: 0,
            approved: 0
        };
        setWorksAt(_object_spread_props(_object_spread({}, worksAt), {
            [key]: {
                pending: externallySign ? pending : pending + 1,
                approved: externallySign ? approved + 1 : approved
            }
        }));
    };
}
